<div class="footer-links-container">
  @for (group of footerLinkGroups; track group) {
    <div class="footer-links-group">
      <div class="group-title">{{ group.name | translate }}</div>
      @for (link of group.items; track link) {
          @if (link.link) {
            <div class="group-item-link pointer">
              <a [href]="link.link" target="_blank">{{link.name | translate}}</a>
            </div>
          }
          @if (link.route) {
            <div class="group-item-link pointer" [routerLink]="link.route" [fragment]="link.fragment">{{ link.name | translate }}</div>
          }
      }
    </div>
  }
</div>
